import axios from '../helpers/axios';

const FLOW_KEY = 'alotb.vkid.flow.v1';
const createRandom = (length = 32) => {
  const bytes = new Uint8Array(length);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, b => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'[b % 64]).join('');
};
const challengeFor = async verifier => {
  const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  const bytes = new Uint8Array(digest);
  let binary = '';
  bytes.forEach(b => { binary += String.fromCharCode(b); });
  return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};
export async function beginVkId({ mode = 'login' } = {}) {
  if (mode !== 'login' && mode !== 'link') throw new Error('Неизвестный режим VK ID');
  if (!window.crypto?.subtle) throw new Error('Для VK ID требуется HTTPS или localhost');
  const { data } = await axios.get('/auth/vk/config');
  if (!data?.enabled) throw new Error('VK ID ещё не настроен в ALOTB');
  const state = createRandom(32);
  const verifier = createRandom(64);
  const challenge = await challengeFor(verifier);
  const flow = { state, verifier, mode, createdAt: Date.now() };
  window.sessionStorage.setItem(FLOW_KEY, JSON.stringify(flow));
  const query = new URLSearchParams({ response_type: 'code', client_id: String(data.appId),
    redirect_uri: data.redirectUri, state, scope: 'phone email', code_challenge: challenge,
    code_challenge_method: 'S256' });
  window.location.assign(`https://id.vk.com/authorize?${query.toString()}`);
}
export function consumeVkIdFlow(returnedState) {
  const raw = window.sessionStorage.getItem(FLOW_KEY);
  window.sessionStorage.removeItem(FLOW_KEY);
  let flow;
  try { flow = JSON.parse(raw || 'null'); } catch (_) { flow = null; }
  if (!flow || typeof returnedState !== 'string' || flow.state !== returnedState ||
      Date.now() - flow.createdAt > 10 * 60 * 1000) throw new Error('Сеанс VK ID недействителен. Повторите вход.');
  return flow;
}
export async function isVkIdEnabled() {
  try { const { data } = await axios.get('/auth/vk/config'); return !!data?.enabled; }
  catch (_) { return false; }
}
